import Axios, { AxiosError } from 'axios'
import { API_URL } from 'constants/config'
import { errorInterceptor } from 'modules/api'
import storage from 'modules/storage'
import {
  headersJson,
  paramsSerializerToSnakeCaseArrayBrackets,
  transformRequestToSnakeCase,
  transformResponseToCamelCase,
} from 'packages/api'

const axios = Axios.create({
  baseURL: API_URL,
  timeout: 30000,
  paramsSerializer: paramsSerializerToSnakeCaseArrayBrackets,
  transformResponse: transformResponseToCamelCase,
  transformRequest: transformRequestToSnakeCase,
  headers: headersJson,
})

const setAxiosAuthorizationToken = (token: null | string): void => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete axios.defaults.headers.common.Authorization
  }
}

const unauthenticatedRequestInterceptor = (error: AxiosError) => {
  const originalRequest = error.config

  if (error.response?.status === 401) {
    storage.clearToken()
    location.reload()
    if (!originalRequest.headers) {
      originalRequest.headers = {}
    }
    delete originalRequest.headers.Authorization
    return { data: { data: null } }
  }

  return Promise.reject(error)
}

axios.interceptors.response.use((response) => response, unauthenticatedRequestInterceptor)
axios.interceptors.response.use((response) => response, errorInterceptor)

export { axios, setAxiosAuthorizationToken }
